import { render } from "./SendNotificationInput.vue?vue&type=template&id=f5d709cc&scoped=true"
import script from "./SendNotificationInput.vue?vue&type=script&lang=js"
export * from "./SendNotificationInput.vue?vue&type=script&lang=js"

import "./SendNotificationInput.vue?vue&type=style&index=0&id=f5d709cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d709cc"]])

export default __exports__